import StateItemDesktop from './StateItemDesktop'
function StateDesktop({states})
{
    return (
      <div id="states-desktop" className="flex flex-col py-[60px] px-[70px]">
        <span className="font-noto-sans text-[48px] font-[600] text-greyTitleBase900 text-left">
          Find jobs in your local area
        </span>
        <div id="state-item-desktop-container" className='mt-[73px] grid md:grid-cols-4 sm:grid-cols-2 gap-x-[20px] gap-y-[65px] h-[100%]'>
          {states.map((state) => {
            return <StateItemDesktop key={state.id} state={state}/>
          })}
        </div>
      </div>
    )

}

export default StateDesktop;